import React, { useState, useCallback } from 'react';

import config from 'config';
import styled from 'styled-components';

import FableticsModal from '~/shared/components/FableticsModal';
import useMembershipPrice from '~/shared/utils/useMembershipPrice';
import { Link } from '~/techstyle-shared/next-routes';
import { AssetContainer } from '~/techstyle-shared/react-assets';
import { useBreakpoint } from '~/techstyle-shared/react-components';
import {
  defineMessages,
  useIntl,
  FormattedMessage,
} from '~/techstyle-shared/react-intl';

const Wrapper = styled.div`
  font-size: 12px;
  line-height: 16px;
  margin: 8px 0 20px 0;
  color: ${({ theme }) => theme.colors.textDefault};
`;

const ModalLink = styled.a`
  margin-top: 16px;
  font-size: inherit;
  color: ${({ theme }) => theme.colors.learnMoreLink};
  text-decoration: underline;
  display: block;
`;

const transitionProps = {
  enter: { opacity: 1, transform: 'scale(1, 1)' },
  from: { opacity: 0, transform: 'scale(0.5, 0.5)' },
  leave: { opacity: 0, transform: 'scale(0.5, 0.5)' },
};

const messages = defineMessages({
  learnMore: {
    id: 'pdp_membership_select.learn_more',
    defaultMessage: 'Learn more about our VIP membership',
  },
});

function VIPOptInMessage() {
  const membershipPrice = useMembershipPrice({ asCurrency: true });
  const intl = useIntl();
  const howItWorksLink = config.get('public.brand.howItWorksLink');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isMobile } = useBreakpoint();
  const learnMoreAsset = isMobile
    ? config.get('public.brand.learnMorePopup.mobile')
    : config.get('public.brand.learnMorePopup.desktop');

  const handleModalOpen = useCallback((event) => {
    event.preventDefault();
    setIsModalOpen(true);
  }, []);

  return (
    <Wrapper>
      <FormattedMessage
        id="pdp_membership_select.vip_disclosure_v2"
        defaultMessage="After your first purchase, you will be charged {membershipPrice} each month for a Member Credit, unless you “Skip” between the 1st and the 5th. You have 12 months to redeem each credit for any item or outfit up to $80, before the credit expires. Cancel your membership anytime online or by phone."
        values={{
          membershipPrice,
        }}
      />
      <Link href={howItWorksLink}>
        <ModalLink
          onClick={handleModalOpen}
          data-autotag="pdp-learn-more-membership-link"
        >
          <FormattedMessage
            id="pdp_membership_select.learn_more"
            defaultMessage="Learn more about our VIP membership"
          />
        </ModalLink>
      </Link>
      <FableticsModal
        title={intl.formatMessage(messages.learnMore)}
        isOpen={isModalOpen}
        onExit={() => setIsModalOpen(false)}
        transitionEnter={transitionProps.enter}
        transitionFrom={transitionProps.from}
        transitionLeave={transitionProps.leave}
        showCloseButton
      >
        <AssetContainer name={learnMoreAsset} aspectRatio="auto" />
      </FableticsModal>
    </Wrapper>
  );
}

export default VIPOptInMessage;
